<template>
  <div class="record-container">
    <medical-record></medical-record>
  </div>
</template>

<style lang="less" scoped>
  .record-container{
    position: relative;
    margin-top: 44px;
  }
</style>

<script type="text/javascript">
  import medicalRecord from '@/components/Patient/MedicalRecord/index'
  export default {
    data() {
      return {}
    },
    components: {
      medicalRecord
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Patient/ConsultingRoom/record.vue